import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_226: DocMigration = {
  maxSchemaVersion: "0.0.226",
  description: "Change names of footing and pier type.",
  apply(json: any) {
    if (json.settings) {
      for (const settingId in json.settings) {
        const setting = json.settings[settingId];
        if (setting.type === "FOUNDATION_CATALOG_SETTINGS") {
          for (const assemblyId in setting.foundationAssemblies) {
            const assembly = setting.foundationAssemblies[assemblyId];
            if (assembly.assemblySystem === "CONCRETE_PIER") {
              assembly.pierId = assembly.columnId;
              delete assembly.columnId;
            }
          }
          for (const componentId in setting.foundationComponents) {
            const component = setting.foundationComponents[componentId];
            if (component.componentType === "FOOTING") {
              if (component.footingType === "RECTANGULAR_PAD") {
                component.footingType = "RECTANGULAR_ISOLATED";
              } else if (component.footingType === "CIRCULAR_PAD") {
                component.footingType = "CIRCULAR_ISOLATED";
              }
            }
            if (component.componentType === "COLUMN") {
              component.componentType = "PIER";
              if (component.columnType === "RECTANGULAR") {
                component.pierType = "RECTANGULAR_CIP";
                component.pierWidth = component.columnWidth;
                component.pierLength = component.columnLength;
                delete component.columnWidth;
                delete component.columnLength;
              } else if (component.columnType === "CIRCULAR") {
                component.pierType = "CIRCULAR_CIP";
                component.pierRadius = component.columnRadius;
                delete component.columnRadius;
              }
              delete component.columnType;
            }
          }
        }
      }
    }
    return json;
  },
};

export default migration_0_0_226;
